import React from "react";
import { ShieldCheck, Gem, Users, Leaf, Lightbulb } from "lucide-react";
import { Overline } from "./Shared";
import { useReveal } from "../hooks/useReveal";

const ICONS = { ShieldCheck, Gem, Users, Leaf, Lightbulb };

export const Values = ({ t }) => {
  const v = t.values;
  const { ref, visible } = useReveal();

  return (
    <section id="values" data-testid="values-section" className="relative py-24 sm:py-32 bg-aa-green overflow-hidden">
      {/* faint diamond pattern */}
      <div className="diamond-strip absolute top-0 left-0 right-0 opacity-30" />
      <div ref={ref} className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className={`text-center reveal ${visible ? "is-visible" : ""}`}>
          <Overline>{v.overline}</Overline>
          <h2 className="font-heading font-light text-aa-cream mt-5 text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            {v.title}
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {v.items.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <div
                key={i}
                data-testid={`value-card-${i}`}
                className={`group flex flex-col items-center text-center p-8 border border-aa-gold/15 hover:border-aa-gold/60 transition-all duration-500 hover:-translate-y-1.5 reveal ${
                  visible ? "is-visible" : ""
                }`}
                style={{ transitionDelay: `${i * 0.08}s` }}
              >
                <div className="text-aa-gold transition-transform duration-500 group-hover:scale-110">
                  {Icon && <Icon size={40} strokeWidth={1} />}
                </div>
                <div className="mt-5 font-heading text-base sm:text-lg text-aa-cream tracking-wide uppercase">
                  {item.title}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
